import React, { useState } from "react";
import { EditorDialog, Field, Area, SelectField, ActiveSwitch, ManageList, linesToList, listToLines } from "@/components/admin/shared";
import { ImageUpload } from "@/components/ImageUpload";
import { useCrud } from "@/components/admin/useCrud";

const CATEGORIES = ["Weight Loss", "Weight Gain", "Diabetes", "PCOS", "Thyroid", "Fatty Liver", "Digestive Health", "Heart Health", "Kidney Health", "Healthy Lifestyle"];
const ICONS = ["HeartPulse", "Activity", "ShieldCheck", "Zap", "Smile", "Scale", "TrendingUp", "Leaf", "Droplets", "Sun"];
const EMPTY = { title: "", category: CATEGORIES[0], icon: "HeartPulse", image: "", description: "", dos: [], donts: [], cautions: "", recommended_foods: [], active: true };

export const AdminGuides = ({ guides, setGuides }) => {
  const c = useCrud("guides", guides, setGuides);
  return (
    <>
      <ManageList title="General Guidance" prefix="admin-guide" items={c.filtered} query={c.query} setQuery={c.setQuery} nameKey="title"
        onAdd={() => c.setEditing(EMPTY)} onEdit={c.setEditing} onDelete={c.remove} subtitle={(g) => g.category} />
      {c.editing && <GuideEditor guide={c.editing} onClose={() => c.setEditing(null)} onSave={c.save} saving={c.saving} />}
    </>
  );
};

const GuideEditor = ({ guide, onClose, onSave, saving }) => {
  const [f, setF] = useState({ ...guide, dos: listToLines(guide.dos), donts: listToLines(guide.donts), recommended_foods: listToLines(guide.recommended_foods) });
  const set = (k) => (e) => setF((x) => ({ ...x, [k]: e.target.value }));
  const submit = () => onSave(
    { title: f.title, category: f.category, icon: f.icon, image: f.image || "", description: f.description, dos: linesToList(f.dos), donts: linesToList(f.donts), cautions: f.cautions, recommended_foods: linesToList(f.recommended_foods), active: f.active },
    (p) => (!p.title.trim() ? "Title is required" : !p.description.trim() ? "Description is required" : null),
  );
  return (
    <EditorDialog title={guide.id ? "Edit Guidance" : "Add Guidance"} testid="guide-editor" onClose={onClose} onSave={submit} saving={saving}>
      <Field label="Title" testid="guide-edit-title" value={f.title} onChange={set("title")} />
      <div className="grid grid-cols-2 gap-2">
        <SelectField label="Category" testid="guide-edit-category" value={f.category} onChange={set("category")} options={CATEGORIES} />
        <SelectField label="Icon" testid="guide-edit-icon" value={f.icon} onChange={set("icon")} options={ICONS} />
      </div>
      <ImageUpload value={f.image} onChange={(v) => setF((x) => ({ ...x, image: v }))} testid="guide-edit-image" />
      <Area label="Description" testid="guide-edit-description" rows={3} value={f.description} onChange={set("description")} />
      <Area label="Do's (one per line)" testid="guide-edit-dos" rows={4} value={f.dos} onChange={set("dos")} />
      <Area label="Don'ts (one per line)" testid="guide-edit-donts" rows={4} value={f.donts} onChange={set("donts")} />
      <Area label="Recommended foods (one per line)" testid="guide-edit-foods" rows={3} value={f.recommended_foods} onChange={set("recommended_foods")} />
      <Area label="Caution note" testid="guide-edit-cautions" rows={2} value={f.cautions} onChange={set("cautions")} />
      <ActiveSwitch checked={f.active !== false} onChange={(v) => setF((x) => ({ ...x, active: v }))} testid="guide-edit-active" />
    </EditorDialog>
  );
};
